module.exports = __webpack_public_path__ + "static/Joro-a5efc877ac9ab3f16aba4f90b7b7b698.jpg";